import React from 'react'
import SkeletonLoader from 'src/components/common/skeletonLoading'
import { LayoutCardsColumns } from '../Retencion.styles'
import Dropdown from 'src/components/common/Dropdown/Dropdown'
import { useSelector } from 'react-redux'
import { selectProspects } from 'src/redux/prospects/prospectsSlice'

const CostumerService = ({ onChange, data, loading }: any) => {
    const { catalogs: { attentions, typification, recommendations, customer_success } } = useSelector(selectProspects);
    const hasCatalogs = customer_success.length + attentions.length + typification.length + recommendations.length > 0;

    const handleOnChange = (value: string | number, name: string) => {
        onChange({ value, name, id: data?.id, ticket_id: data?.ticket_id, user_id: data?.user_id })
    }

    if (loading || !hasCatalogs) return (
        <>
            <SkeletonLoader width='219px' height='18px' count={3} />
            <SkeletonLoader width='140px' height='18px' />
        </>
    )
    return (
        <LayoutCardsColumns>
            <div className='container'>
                <span className="label">Asignación:</span>
                <Dropdown
                    arraySelect={customer_success}
                    currentSelected={customer_success.findIndex(item => item.value === data?.assigned_user_id) + 1}
                    colorSelect={'blue'}
                    isDisabled={Boolean(data?.assigned_user_id)}
                    nullMessage='Sin asignar'
                    onChangeSelect={(e) => handleOnChange(e, 'assigned_user_id')}
                />
            </div>
            <div className='container'>
                <span className="label">Tipo de Atención:</span>
                <Dropdown
                    arraySelect={attentions}
                    currentSelected={attentions.findIndex(item => item.value === data?.attention_id) + 1}
                    colorSelect={'grey'}
                    isDisabled={false}
                    nullMessage='Sin asignar'
                    onChangeSelect={(e) => handleOnChange(e, 'attention_id')}
                />
            </div>
            <div className='container'>
                <span className="label">Recomendación:</span>
                <Dropdown
                    arraySelect={recommendations}
                    currentSelected={recommendations.findIndex(item => item.value === data?.recommendation_id) + 1}
                    colorSelect={'ocean'}
                    isDisabled={false}
                    nullMessage='Sin asignar'
                    onChangeSelect={(e) => handleOnChange(e, 'recommendation_id')}
                />
            </div>
            <div className='container'>
                <span className="label">Tipificación:</span>
                <Dropdown
                    arraySelect={typification}
                    currentSelected={typification.findIndex(item => item.value === data?.typification_id) + 1}
                    colorSelect={'grey'}
                    nullMessage='Sin asignar'
                    isDisabled={false}
                    onChangeSelect={(e) => handleOnChange(e, 'typification_id')}
                />
            </div>
        </LayoutCardsColumns>
    )
}

export default CostumerService